import { can } from '#/modules/infra/auth/can';

/**
 * 依 permissions 過濾 Aside 選單。
 * - `permission`：單一碼
 * - `permissionAll`：全部碼皆需有
 * - `permissionAny`：任一碼即可（群組／hub 範本）；**空陣列＝不過濾（維持可見）**
 * @param {Array} menuList
 * @param {string[]} permissions
 */
export function filterAsideMenuByPermissions(menuList, permissions) {
  if (!Array.isArray(menuList)) {
    return [];
  }

  function isAllowed(item) {
    if (Array.isArray(item.permissionAll) && item.permissionAll.length > 0) {
      return item.permissionAll.every((code) => can(permissions, code));
    }
    if (Array.isArray(item.permissionAny) && item.permissionAny.length > 0) {
      return item.permissionAny.some((code) => can(permissions, code));
    }
    if (item.permission) {
      return can(permissions, item.permission);
    }
    return true;
  }

  return menuList
    .map((item) => {
      if (!isAllowed(item)) {
        return null;
      }

      if (!item.children?.length) {
        return item;
      }

      const children = item.children.filter(isAllowed);
      if (children.length === 0) {
        return null;
      }

      return { ...item, children };
    })
    .filter(Boolean);
}
